import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  ref: "mapBoxContainer",
  class: "googleMap",
  style: {"width":"100%","height":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FooterMenu = _resolveComponent("FooterMenu")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "fill-height pa-0",
    fluid: "",
    style: {"position":"relative"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, null, 512),
      (_ctx.showFooterMenu && _ctx.mapRef && _ctx.scaleControlRef)
        ? (_openBlock(), _createBlock(_component_FooterMenu, {
            key: 0,
            mapValue: _ctx.mapRef,
            scaleControlValue: _ctx.scaleControlRef,
            legendData: _ctx.legendData,
            outputLegendData: _ctx.outputLegendData,
            areaLegendData: _ctx.areaLegendData,
            rasterLegendData: _ctx.rasterLegendData,
            showLocationOutput: _ctx.showLocationOutput
          }, null, 8, ["mapValue", "scaleControlValue", "legendData", "outputLegendData", "areaLegendData", "rasterLegendData", "showLocationOutput"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}